// @flow

import { push }                        from "react-router-redux";
import { isPromise }                   from "diskho";
import { reset   as resetCheckout,
         SUCCESS as CHECKOUT_SUCCESS } from "store-reducers/checkout";
import { LOADED  as ORDER_LOADED,
         set     as setOrder }         from "store-reducers/order";
import { LOGOUT }                      from "store-reducers/customer";
import { qtyLimiter }                  from "../reducers/cart";
import { setQtyLimit }                 from "../reducers/procurement";

const sideEffectsMiddleware = store => next => action => {
  next(action);

  if (!isPromise(action.payload)) {
    return;
  }

  if (process.browser) {
    action.payload.then(x => x, data => {
      if (data && data.errorCode === 3000) {
        next(push("/logout"));
      }

      if (data && data.errorCode === 14001) {
        data.httpBody.data.exceededLimits.forEach(x => {
          if (x.mode === "QTY") {
            const affectedProducts = store.getState().cart.items.filter(i => x.skus.includes(i.product.sku));

            next(qtyLimiter(x.excess, x.skus));

            // use total qty of affected items to find the theoretical max qty limit
            next(setQtyLimit(affectedProducts.reduce((a, v) => a + v.qty, 0) - x.excess, x.skus));
          }
        });

        return;
      }
    });
  }

  if (action.type === CHECKOUT_SUCCESS) {
    return action.payload.then(resp => next(setOrder(resp)));
  }

  if (action.type === ORDER_LOADED) {
    return action.payload.then(() => next(resetCheckout()));
  }

  if (action.type === LOGOUT) {
    return action.payload.then(() => {
      next(resetCheckout());
    });
  }
};

export default sideEffectsMiddleware;
